// @flow

import {
  createResource,
  type ActionReturn,
  type FetchResponse,
  type Resource,
  type ResourceActionOptions,
} from '@gandi/resource/redux';

import type { FullState, Dispatch, ResourceThunkAction } from '../../../types';
import type { Service, ServicePackage } from '../../types/marketplace';

export const resource: Resource<> = createResource('marketplace');

export const getCurrentServicePackage = (service: Service): ?ServicePackage =>
  (service?.packages || []).find(p => !!p.current);

// actions
export type FetchDomainServicesAction = (
  fqdn: string,
  options?: ResourceActionOptions,
) => ResourceThunkAction;
export const fetchDomainServices: FetchDomainServicesAction =
  (fqdn, options?) => (dispatch: Dispatch) =>
    dispatch(
      // shop is only interrested by installed services
      resource.fetch(`/marketplace/domains/${fqdn}/services?installed=true`, {
        ...options,
        label: fqdn,
        // $FlowFixMe[incompatible-exact]
        on200: (response: FetchResponse<>) => response.data,
        // $FlowFixMe[incompatible-exact]
        not200: (response: FetchResponse<>) => Promise.reject(response),
      }),
    );

export type FetchDomainServiceAction<R = ActionReturn> = (
  fqdn: string,
  serviceId: string,
  options?: ResourceActionOptions,
) => R;
export const fetchDomainService: FetchDomainServiceAction<
  ResourceThunkAction,
> = (fqdn, serviceId, options?) => (dispatch: Dispatch) =>
  dispatch(
    resource.fetchOne(`/marketplace/domains/${fqdn}/services/${serviceId}`, {
      ...options,
      label: `${fqdn}_${serviceId}`,
      // $FlowFixMe[incompatible-exact]
      on200: (response: FetchResponse<>) => response,
      // $FlowFixMe[incompatible-exact]
      not200: (response: FetchResponse<>) => Promise.reject(response),
    }),
  );

// selectors
export const selectInstalledServices = (
  state: FullState,
  fqdn: string,
): Array<Service> =>
  (state.domainRenew.marketplace[fqdn] || []).filter(
    service => service.installed,
  );
